import axios from 'axios';

export default {
  namespaced: true,
  state: {
    documents: []
  },
  mutations: {
    getDocuments(state, docs) {
      state.documents = [];
      docs.forEach(doc => {
        doc.translationDocuments.sort((a, b) => {
          if (
            a.languageNavigation.description < b.languageNavigation.description
          ) {
            return -1;
          } else if (
            a.languageNavigation.description > b.languageNavigation.description
          ) {
            return 1;
          } else {
            return 0;
          }
        });
        state.documents.push(doc);
      });
    }
  },
  actions: {
    getDocuments({ commit }, axiosParams) {
      return new Promise(resolve => {
        axios.get('/Document', { params: axiosParams }).then(response => {
          commit('getDocuments', response.data);
          resolve(response);
        });
      });
    }
  }
};
